import { DeleteIcon, EditIcon, LabeledIcon } from 'components/Icon';
import React from 'react';
import { useHistory } from 'react-router';

import * as paths from 'app-router/paths';
import { useStore } from 'stores';
import { Requester } from 'stores/RequesterStore';
import { SimpleInlineHelp } from 'components/InlineHelp';

interface Props
{
  requester: Requester,
}

export const ViewForm: React.FC<Props> = ({requester}: Props) =>
{
  const history = useHistory();
  const { uiStore, requesterStore } = useStore();

  const locationState = history.location.state as { isCancelRequired: boolean };

  const editRequesterHandler = () => history.push(paths.buildRequesterEditPath(requester.token || ''));
  const createRequesterHandler = () => history.push(paths.buildRequesterCreatePath());
  const toListHandler = () => history.push(paths.buildRequesterListPath());
  const cancelHandler = () =>
  {
    requesterStore.requester.clearError();
    history.goBack();
  };
  const deleteRequesterHandler = async () =>
  {
    if (window.confirm(uiStore.labels.pages.audience.deleteRequesterConfirmation.apply({requesterName: requester.name})))
    {
      await requesterStore.deleteAsync(requester.token || '');
      if (!requesterStore.requester.isError)
      {
        history.push(paths.buildRequesterListPath());
      }
    }
  };
  return (
    <>
      <div className="fields">
        <label>
          {uiStore.labels.common.forms.requester.token.label}:
          <input type="text" value={requester.token} readOnly={true} />
        </label>
        <label>
          {uiStore.labels.common.forms.requester.name.label}:
          <input type="text" value={requester.name} readOnly={true} />
        </label>
        <label>
          {uiStore.labels.common.forms.requester.path.label}:<SimpleInlineHelp>{uiStore.labels.help.audience.requesters.path.about}</SimpleInlineHelp>
          <input type="text" value={requester.path} readOnly={true} />
        </label>

        <div className="info">
          <p>{uiStore.labels.common.forms.requester.createdBy.apply({by: requester.created_by, at: new Date(Date.parse(requester.created_at || '')).toLocaleString(),})}</p>
          <p>{uiStore.labels.common.forms.requester.updatedBy.apply({by: requester.updated_by, at: new Date(Date.parse(requester.updated_at || '')).toLocaleString(),})}</p>
        </div>
      </div>

      <div className="actions">
        <button onClick={editRequesterHandler}><LabeledIcon label={uiStore.labels.common.forms.edit}><EditIcon /></LabeledIcon></button>
        <button onClick={deleteRequesterHandler}><LabeledIcon label={uiStore.labels.common.forms.delete}><DeleteIcon/></LabeledIcon></button>
        <button onClick={createRequesterHandler}>{uiStore.labels.common.forms.createAnother}</button>
        {
          locationState?.isCancelRequired
          ? <button onClick={cancelHandler}>{uiStore.labels.common.forms.cancel}</button>
          : <button onClick={toListHandler}>{uiStore.labels.common.forms.toList}</button>
        }
      </div>
    </>
  );
};